$('.modal-buy-tickets').each(function () {

    let calendar = $(this),
        monthPrevious = $(this).find('.month-previous'),
        monthNext = $(this).find('.month-next'),
        activeMonthIndex = 0,
        monthItems = $(this).find('.month-option'),
        dayButtons = $(this).find('.day-label-button'),
        selectedDay = null,
        selectedTicket = null,
        ticketDisplayContainer = $(this).find('.ticket-selection'),
        selectedTicketDisplay = $(this).find('.selected-ticket-display'),
        selectedTicketLink = $(this).find('.selected-ticket-link'),
        cancelTicketSelection = $(this).find('.cancel-ticket-selection'),
        moreTicketsContainer = $(this).find('.more-tickets-expand'),
        viewMoreTicketsButton = $(this).find('.view-more-dates-btn');

    // watch for <a> clicks that have an href of # + $(this).attr('id') globally to trigger modal opening from anywhere
    $(document).on('click', 'a[href="#' + $(this).attr('id') + '"]', function (e) {
        e.preventDefault();
        e.stopPropagation();

        calendar.modal('show');
    });

    if(window.location.hash === '#' + $(this).attr('id')) {
        setTimeout(function () {
            calendar.modal('show');
        }, 500);
    }

    viewMoreTicketsButton.on('click', function () {
        moreTicketsContainer.slideToggle();
        viewMoreTicketsButton.toggleClass('active');
        if(viewMoreTicketsButton.hasClass('active')) {
            viewMoreTicketsButton.html('View Less Dates...');
            calendar.animate({
                scrollTop: calendar.scrollTop() + 500
            }, 500);
        } else {
            viewMoreTicketsButton.html('View More Dates...');
        }
    });

    monthPrevious.on('click', function () {
        if(activeMonthIndex > 0) {
            activeMonthIndex--;
            monthItems.removeClass('is-active');
            calendar.find('.month-option-' + activeMonthIndex).addClass('is-active');
        }
    });

    monthNext.on('click', function () {
        if(activeMonthIndex < monthItems.length - 1) {
            activeMonthIndex++;
            monthItems.removeClass('is-active');
            calendar.find('.month-option-' + activeMonthIndex).addClass('is-active');
        }
    });

    cancelTicketSelection.on('click', function () {
        dayButtons.parent().removeClass('is-selected');
        selectedTicketDisplay.text('');
        selectedTicketLink.attr('href', '#');
        ticketDisplayContainer.addClass('d-none');
    });

    // set the first day button to be selected

    dayButtons.on('click', function () {

        if($(this).parent().hasClass('is-selected')) {
            $(this).parent().removeClass('is-selected');
            selectedTicketDisplay.text('');
            selectedTicketLink.attr('href', '#');
            ticketDisplayContainer.addClass('d-none');
        } else {
            dayButtons.parent().removeClass('is-selected');
            $(this).parent().addClass('is-selected');

            if($(this).hasClass('has-multiple-events')) {
                console.log('show time selections');
            } else {
                if(ticketDisplayContainer.hasClass('d-none')) {
                    ticketDisplayContainer.removeClass('d-none');
                }

                selectedTicketDisplay.text($(this).data('date-display'));
                selectedTicketLink.attr('href', $(this).data('purchase-link'));

                // scroll to the ticket display
                calendar.animate({
                    scrollTop: calendar.scrollTop() + 300
                }, 500);
            }
        }
    });

    dayButtons.first().click();

});
